import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/guagua";

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-primary-200/70 bg-primary-50">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-water-flash-fill text-xl leading-none" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">{siteInfo.name}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">{siteInfo.intro}</p>
            <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-background-50 px-3 py-1.5 text-xs font-medium text-primary-700">
              <i className="ri-sparkling-2-line leading-none" aria-hidden="true"></i>
              {siteInfo.sloganLine}
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-bold text-foreground-950">内容导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-foreground-600 transition-colors hover:text-primary-700">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/collections" className="text-foreground-600 transition-colors hover:text-primary-700">
                  合集导航
                </Link>
              </li>
              <li>
                <Link to="/weekly" className="text-foreground-600 transition-colors hover:text-primary-700">
                  一周盘点
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-600 transition-colors hover:text-primary-700">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-foreground-950">热门分类</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/collections?cat=${cat.id}`}
                    className="inline-flex items-center gap-2 text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    <i className={`${cat.icon} leading-none`} aria-hidden="true"></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-bold text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 leading-none" aria-hidden="true"></i>
                <a href={`mailto:${siteInfo.email}`} className="break-all transition-colors hover:text-primary-700">
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 leading-none" aria-hidden="true"></i>
                <span>每周固定更新盘点</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-200/70 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 吃瓜合集导航 · 内容均为公开信息主题化整理，请理性围观</p>
          <p className="flex items-center gap-4">
            <span>按热度整理</span>
            <span className="h-1 w-1 rounded-full bg-foreground-300" aria-hidden="true"></span>
            <span>按合集浏览</span>
          </p>
        </div>
      </div>
    </footer>
  );
}